"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Typography_1 = require("../../Typography");
var Utility_1 = require("../../Icons/Utility");
var Textbox_1 = __importDefault(require("../Textbox"));
var styles_1 = __importDefault(require("../Textbox/styles"));
var styles_2 = __importDefault(require("./styles"));
var classnames_1 = __importDefault(require("classnames"));
var useTextBoxStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
var useStyles = (0, react_jss_1.createUseStyles)(styles_2.default);
// eslint-disable-next-line no-redeclare
var SplitTextbox = function (_a) {
    var id = _a.id, children = _a.children, className = _a.className, topLevelLabel = _a.label, disabled = _a.disabled, errorMessage = _a.errorMessage, helperText = _a.helperText, onGroupChange = _a.onGroupChange, options = _a.options, tooltip = _a.tooltip;
    var classes = useStyles();
    var textBoxClasses = useTextBoxStyles();
    var hasError = errorMessage && !disabled;
    var classname = (0, classnames_1.default)(textBoxClasses.root, className, disabled && textBoxClasses.disabled);
    (0, react_1.useEffect)(function () {
        var childrenLength = react_1.default.Children.count(children);
        if ((options && (options.length < 2 || options.length > 3)) ||
            (children && (childrenLength < 2 || childrenLength > 3)))
            console.warn('You must pass either 2 or 3 text objects. See https://mortar.policygenius.com for more details.');
    }, [options, children]);
    var initialState = {};
    options === null || options === void 0 ? void 0 : options.forEach(function (textbox) {
        var textBoxId = textbox.id, defaultValue = textbox.defaultValue;
        initialState[textBoxId] = defaultValue !== null && defaultValue !== void 0 ? defaultValue : '';
    });
    var _b = (0, react_1.useState)(initialState), inputValues = _b[0], setInputValues = _b[1];
    var renderTextboxesWithOptions = function () {
        return options === null || options === void 0 ? void 0 : options.map(function (textbox, idx) {
            var textBoxId = textbox.id, name = textbox.name, type = textbox.type, suffix = textbox.suffix, prefix = textbox.prefix, onChange = textbox.onChange, fieldTooltip = textbox.tooltip, inputAttributes = __rest(textbox, ["id", "name", "type", "suffix", "prefix", "onChange", "tooltip"]);
            var lastTextbox = idx === options.length - 1;
            var onInputChange = function (e) {
                var _a;
                var newValues = __assign(__assign({}, inputValues), (_a = {}, _a[textBoxId] = e.target.value, _a));
                setInputValues(newValues);
                if (onGroupChange) {
                    onGroupChange(e, newValues);
                }
                if (onChange) {
                    onChange(e);
                }
            };
            var ariaAttributes = (function () {
                var aria = {};
                if (hasError) {
                    aria['aria-invalid'] = 'true';
                    aria['aria-describedby'] = "".concat(id, "_err");
                }
                return aria;
            })();
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Textbox_1.default, __assign({}, ariaAttributes, inputAttributes, { className: (0, classnames_1.default)(classes.fieldWrapper, classes.fieldWrapperWithChildren, hasError && classes.error), showLabel: !topLevelLabel, name: name, id: textBoxId, type: type, disabled: disabled, onChange: onInputChange, value: inputValues[textBoxId], suffix: suffix, prefix: prefix, 
                    // display the tooltip by passing it into the last textbox child
                    tooltip: !!tooltip && lastTextbox ? tooltip : fieldTooltip }))));
        });
    };
    var renderTextboxesWithChildren = function () {
        //  `child` below is deliberately typed as `any`. The expected children here are Textbox or MaskedTextbox, and ideally we'd use the union of
        //  those two components' props to type this. However MaskedTextbox brings in an external library, so by importing its types in this file
        //  we'd make it impossible to tree-shake out that library, even if you aren't using the masked version.
        return react_1.default.Children.map(children, function (child, idx) {
            var _a, _b;
            var lastTextbox = idx === react_1.default.Children.count(children) - 1;
            if (!['MaskedTextbox', 'Textbox'].includes((_b = (_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === null || _b === void 0 ? void 0 : _b.replace('', ''))) {
                console.warn('Textbox and MaskedTextbox are the only valid children of SplitTextbox. Other nodes will be skipped.');
                return null;
            }
            return react_1.default.cloneElement(child, {
                className: (0, classnames_1.default)(child.props.className, classes.fieldWrapper, classes.fieldWrapperWithChildren, hasError && classes.error),
                showLabel: !topLevelLabel,
                // display the "global" tooltip by passing it into the last textbox child
                tooltip: !!tooltip && lastTextbox ? tooltip : child.props.tooltip,
                // unset these since we'll be using the top level messages
                errorMessage: undefined,
                helperText: undefined
            });
        });
    };
    var ErrorMessage = function () {
        return (react_1.default.createElement("div", { className: classes.errorHelp },
            react_1.default.createElement(Utility_1.AlertWarning, { color: "warningAccessible", ariaHidden: true }),
            react_1.default.createElement(Typography_1.UtilityText, { id: "".concat(id, "_err"), size: "xsmall", color: "secondary", className: classes.errorHelpText }, errorMessage)));
    };
    var HelpMessage = function () {
        return (react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: disabled ? 'disabled' : 'secondary', className: classes.help }, helperText));
    };
    var DisplayMessage = function () {
        if (hasError)
            return react_1.default.createElement(ErrorMessage, null);
        if (helperText)
            return react_1.default.createElement(HelpMessage, null);
        return null;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "".concat(id, "-wrap"), className: classname },
            topLevelLabel && (react_1.default.createElement("div", { className: classes.labels },
                react_1.default.createElement(Typography_1.LabelText, { size: "large", color: disabled ? 'disabled' : 'primary' }, topLevelLabel),
                tooltip)),
            react_1.default.createElement("div", { "data-testid": "textboxes-wrapper", className: classes.textboxes }, options
                ? renderTextboxesWithOptions()
                : renderTextboxesWithChildren())),
        react_1.default.createElement(DisplayMessage, null)));
};
exports.default = SplitTextbox;
